// Central analytics hook. Fires to dataLayer / gtag / Meta Pixel when IDs are configured.
export const trackEvent = (action, params = {}) => {
  try {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: action, ...params });
    if (typeof window.gtag === 'function') window.gtag('event', action, params);
    if (typeof window.fbq === 'function') window.fbq('trackCustom', action, params);
  } catch (e) {
    /* analytics must never break the app */
  }
};
